export const ADDINS_CHANGE_SOURCE = 'Addins';
